export default __webpack_public_path__ + "static/media/class_x_engg.f084b338.png";